import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypePdfIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H4.49438C4.01654 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#FF3333"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#DC0606"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      d="M7.86511 6.74152H12.7341"
      stroke="#AFBDC7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="0.748764"
    />
    <path
      d="M7.86511 8.98871H16.4793"
      stroke="#AFBDC7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="0.748764"
    />
    <path
      d="M7.86511 11.2359H16.4793"
      stroke="#AFBDC7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="0.748764"
    />
    <path
      clipRule="evenodd"
      d="M13.957 17.6029C13.957 17.1063 13.7597 16.63 13.4085 16.2788C13.0574 15.9276 12.581 15.7303 12.0843 15.7303C11.4147 15.7303 10.7735 15.7303 10.7735 15.7303C10.5667 15.7303 10.3989 15.8979 10.3989 16.1048V19.8501C10.3989 20.057 10.5667 20.2247 10.7735 20.2247H12.0843C12.581 20.2247 13.0574 20.0274 13.4085 19.6762C13.7597 19.325 13.957 18.8487 13.957 18.352V17.6029ZM13.2079 17.6029V18.352C13.2079 18.65 13.0895 18.9358 12.8788 19.1466C12.6681 19.3573 12.3823 19.4756 12.0843 19.4756H11.148V16.4793H12.0843C12.3823 16.4793 12.6681 16.5977 12.8788 16.8084C13.0895 17.0192 13.2079 17.3049 13.2079 17.6029Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.4176 15.7303H15.0768C14.87 15.7303 14.7023 15.8979 14.7023 16.1048V19.8501C14.7023 20.0568 14.8701 20.2247 15.0768 20.2247C15.2835 20.2247 15.4513 20.0568 15.4513 19.8501V16.4793H17.4176C17.6243 16.4793 17.7922 16.3115 17.7922 16.1048C17.7922 15.8981 17.6243 15.7303 17.4176 15.7303Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M6.92689 18.5861H8.56159C9.21013 18.5861 9.73588 18.0604 9.73588 17.4118V16.9046C9.73588 16.256 9.21013 15.7303 8.56159 15.7303C7.73121 15.7303 6.55233 15.7303 6.55233 15.7303C6.3455 15.7303 6.17786 15.8979 6.17786 16.1048V19.8501C6.17786 20.0568 6.34568 20.2247 6.55233 20.2247C6.75907 20.2247 6.92689 20.0568 6.92689 19.8501V18.5861ZM6.92689 17.837H8.56159C8.79646 17.837 8.98676 17.6467 8.98685 17.4118V16.9046C8.98676 16.6697 8.79646 16.4793 8.56159 16.4793H6.92689V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.545 18.352H16.9495C17.1562 18.352 17.324 18.1842 17.324 17.9775C17.324 17.7707 17.1562 17.6029 16.9495 17.6029H15.545C15.3382 17.6029 15.1704 17.7707 15.1704 17.9775C15.1704 18.1842 15.3382 18.352 15.545 18.352Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypePdfIcon;
